import { defineComponent as _defineComponent } from 'vue'
import { SimulationDemand } from '@/models/Demand';
import ChangesDetection from '@/components/commons/ChangesDetection.vue';
import Vue, {getCurrentInstance} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultSimpleUserInputForm',
  props: {
    userInput: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change'): void;
}), expose: any, slots: any, attrs: any }) {



// eslint-disable-next-line func-call-spacing


const instance = getCurrentInstance();

const onChange = () => {
  const simulationForm: any = (instance?.proxy.$refs.changesDetection as Vue).$refs.FORM_NAME;
  if (simulationForm && !simulationForm.validate()) {
    console.error('form invalid');
    return;
  }
  emit('change');
};

return { __sfc: true,emit, instance, onChange, ChangesDetection }
}

})